export default __webpack_public_path__ + "static/media/feature--privacy.0c8fd239.png";